import { Laya } from "../../Laya";
import { SpineSkeletonRenderer } from "./normal/SpineSkeletonRenderer";
import { SpineWasmRender } from "./normal/SpineWasmRender";
export class SpineAdapter {
    static initialize() {
        if (window.Spine) {
            SpineAdapter.isWasm = true;
            return window.Spine().then((spine) => {
                SpineAdapter._spine = spine;
                window.spine = spine;
                SpineAdapter.initClass();
                SpineAdapter.bindBuffer(10922 * 12, 10922 * 3);
                SpineAdapter.allAdpat();
                return Promise.resolve();
            });
        }
        else if (window.spine) {
            SpineAdapter.isWasm = false;
            SpineAdapter.adaptJS();
            SpineAdapter.allAdpat();
        }
    }
    static createNormalRender(templet) {
        return SpineAdapter.isWasm ? new SpineWasmRender(templet) : new SpineSkeletonRenderer(templet);
    }
    static allAdpat() {
        let stateProto = window.spine.AnimationState.prototype;
        stateProto.oldApply = stateProto.apply;
        stateProto.applyCache = function (skeleton) {
        };
        stateProto.getCurrentPlayTimeOld = function (trackIndex) {
            return this.getCurrentOld(trackIndex).getAnimationTime();
        };
        stateProto.getCurrentPlayTime = stateProto.getCurrentPlayTimeOld;
        stateProto.getCurrentPlayTimeByCache = function (trackIndex) {
            let entry = this.getCurrent(trackIndex);
            let animationStart = entry.animationStart, animationEnd = entry.animationEnd;
            let duration = animationEnd - animationStart;
            entry.trackLast = entry.nextTrackLast;
            let trackLastWrapped = entry.trackLast % duration;
            let animationTime = entry.getAnimationTime();
            let complete = false;
            if (entry.loop)
                complete = duration == 0 || trackLastWrapped > entry.trackTime % duration;
            else
                complete = animationTime >= animationEnd && entry.animationLast < animationEnd;
            if (complete) {
                this.dispatchEvent(entry, "complete", null);
                entry.nextAnimationLast = -1;
                entry.nextTrackLast = -1;
                return 0;
            }
            entry.nextAnimationLast = animationTime;
            entry.nextTrackLast = entry.trackTime;
            let animationLast = entry.animationLast;
            return Math.max(animationLast, 0);
        };
        let skeletonProto = window.spine.Skeleton.prototype;
        skeletonProto.oldUpdateWorldTransform = skeletonProto.updateWorldTransform;
        skeletonProto.updateWorldTransformCache = function () {
        };
        window.spine.AnimationState.prototype.dispatchEvent = function (entry, type, event) {
            this.eventsObject[type](entry, event);
        };
    }
    static adaptJS() {
        if (window.spine) {
            window.spine.AnimationState.prototype.oldAddListener = window.spine.AnimationState.prototype.addListener;
            window.spine.AnimationState.prototype.addListener = function (data) {
                this.eventsObject = data;
                this.oldAddListener(data);
            };
            let sketonDataProto = window.spine.SkeletonData.prototype;
            sketonDataProto.getAnimationsSize = function () { return this.animations.length; };
            sketonDataProto.getAnimationByIndex = function (index) { return this.animations[index]; };
            sketonDataProto.getSkinIndexByName = function (name) {
                let skins = this.skins;
                for (let i = 0, n = skins.length; i < n; i++) {
                    if (skins[i].name == name) {
                        return i;
                    }
                }
                return -1;
            };
            let skeletonProto = window.spine.Skeleton.prototype;
            skeletonProto.showSkinByIndex = function (index) {
                this.setSkin(this.data.skins[index]);
            };
            let stateProto = window.spine.AnimationState.prototype;
            stateProto.getCurrentOld = stateProto.getCurrent;
            stateProto.getCurrent = function (trackIndex) {
                let result = this.getCurrentOld(trackIndex);
                this.currentTrack = result;
                return result;
            };
        }
    }
    static initClass() {
        let stateProto = window.spine.AnimationState.prototype;
        stateProto.addListener = function (data) {
            this.eventsObject = data;
            this.setListener(SpineAdapter._spine.AnimationStateListenerObject.implement({
                callback: (state, type, entry, event) => {
                    data[SpineAdapter.stateMap[type.value]](entry, event);
                }
            }));
        };
        stateProto.getCurrentOld = stateProto.getCurrent;
        stateProto.setAnimationOld = stateProto.setAnimation;
        stateProto.setAnimation = function (trackIndex, animationName, loop) {
            if (this.__tracks) {
                this.__tracks.length = 0;
            }
            return this.setAnimationOld(trackIndex, animationName, loop);
        };
        stateProto.getCurrent = function (trackIndex) {
            let result;
            let __tracks = this.__tracks;
            if (!__tracks) {
                __tracks = this.__tracks = [];
                result = this.getCurrentOld(trackIndex);
                __tracks[trackIndex] = result;
            }
            else {
                result = __tracks[trackIndex];
            }
            if (!result) {
                result = this.getCurrentOld(trackIndex);
                __tracks[trackIndex] = result;
            }
            this.currentTrack = result;
            return result;
        };
        window.spine.TextureAtlas = TextureAtlas;
        Object.defineProperty(window.spine.Skin.prototype, "attachments", {
            get: function () {
                return this.getAttachments();
            }
        });
        let skeletonProto = window.spine.Skeleton.prototype;
        Object.defineProperty(skeletonProto, "slots", {
            get: function () {
                return this.getSlots();
            }
        });
        Object.defineProperty(skeletonProto, "data", {
            get: function () {
                return this.getData();
            }
        });
        Object.defineProperty(skeletonProto, "bones", {
            get: function () {
                return this.getBones();
            }
        });
        Object.defineProperty(skeletonProto, "color", {
            get: function () {
                return this.getColor();
            }
        });
        let skeletonDataProto = window.spine.SkeletonData.prototype;
        Object.defineProperty(skeletonDataProto, "name", {
            get: function () {
                return this.getName();
            }
        });
        Object.defineProperty(skeletonDataProto, "skins", {
            get: function () {
                return this.getSkins();
            }
        });
        Object.defineProperty(skeletonDataProto, "slots", {
            get: function () {
                return this.getSlots();
            }
        });
        let animationProto = window.spine.Animation.prototype;
        Object.defineProperty(animationProto, "name", {
            get: function () {
                return this.getName();
            }
        });
        Object.defineProperty(animationProto, "duration", {
            get: function () {
                return this.getDuration();
            }
        });
        Object.defineProperty(animationProto, "timelines", {
            get: function () {
                return this.getTimelines();
            }
        });
        Object.defineProperty(skeletonDataProto, "animations", {
            get: function () {
                return this.getAnimations();
            }
        });
        Object.defineProperty(window.spine.Skin.prototype, "name", {
            get: function () {
                return this.getName();
            }
        });
        let slotDataProto = window.spine.SlotData.prototype;
        Object.defineProperty(slotDataProto, "boneData", {
            get: function () {
                return this.getBoneData();
            }
        });
        Object.defineProperty(slotDataProto, "color", {
            get: function () {
                return this.getColor();
            }
        });
        Object.defineProperty(slotDataProto, "index", {
            get: function () {
                return this.getIndex();
            }
        });
        Object.defineProperty(slotDataProto, "attachmentName", {
            get: function () {
                return this.getAttachmentName();
            }
        });
        Object.defineProperty(slotDataProto, "blendMode", {
            get: function () {
                return this.getBlendMode().value;
            }
        });
        Object.defineProperty(window.spine.BoneData.prototype, "index", {
            get: function () {
                return this.getIndex();
            }
        });
        let regionAttachMentProto = window.spine.RegionAttachment.prototype;
        Object.defineProperty(regionAttachMentProto, "color", {
            get: function () {
                return this.getColor();
            }
        });
        Object.defineProperty(regionAttachMentProto, "name", {
            get: function () {
                return this.getName();
            }
        });
        Object.defineProperty(regionAttachMentProto, "offset", {
            get: function () {
                let from = this.getOffset();
                return from;
            }
        });
        Object.defineProperty(regionAttachMentProto, "uvs", {
            get: function () {
                return this.getRotateUVs();
            }
        });
        Object.defineProperty(regionAttachMentProto, "region", {
            get: function () {
                return this;
            }
        });
        Object.defineProperty(regionAttachMentProto, "page", {
            get: function () {
                return this.getPage();
            }
        });
        Object.defineProperty(window.spine.AtlasPage.prototype, "name", {
            get: function () {
                return this.getName();
            }
        });
        let meshAttachmentProto = window.spine.MeshAttachment.prototype;
        Object.defineProperty(meshAttachmentProto, "bones", {
            get: function () {
                return this.getBones();
            }
        });
        Object.defineProperty(meshAttachmentProto, "uvs", {
            get: function () {
                return this.getUVs();
            }
        });
        Object.defineProperty(meshAttachmentProto, "triangles", {
            get: function () {
                return this.getTriangles();
            }
        });
        Object.defineProperty(meshAttachmentProto, "vertices", {
            get: function () {
                let from = this.getVertices();
                return from;
            }
        });
        Object.defineProperty(meshAttachmentProto, "color", {
            get: function () {
                return this.getColor();
            }
        });
        Object.defineProperty(meshAttachmentProto, "region", {
            get: function () {
                return this;
            }
        });
        Object.defineProperty(meshAttachmentProto, "page", {
            get: function () {
                return this.getPage();
            }
        });
        Object.defineProperty(meshAttachmentProto, "name", {
            get: function () {
                return this.getName();
            }
        });
        let eventTimelineProto = window.spine.EventTimeline.prototype;
        Object.defineProperty(eventTimelineProto, "frames", {
            get: function () {
                return this.getFrames();
            }
        });
        Object.defineProperty(eventTimelineProto, "events", {
            get: function () {
                return this.getEvents();
            }
        });
        let attachmentTimelineProto = window.spine.AttachmentTimeline.prototype;
        Object.defineProperty(attachmentTimelineProto, "frames", {
            get: function () {
                return this.getFrames();
            }
        });
        Object.defineProperty(attachmentTimelineProto, "slotIndex", {
            get: function () {
                return this.getSlotIndex();
            }
        });
        Object.defineProperty(attachmentTimelineProto, "attachmentNames", {
            get: function () {
                return this.getAttachmentNames();
            }
        });
        let drawOrderTimelineProto = window.spine.DrawOrderTimeline.prototype;
        Object.defineProperty(drawOrderTimelineProto, "frames", {
            get: function () {
                return this.getFrames();
            }
        });
        Object.defineProperty(drawOrderTimelineProto, "drawOrders", {
            get: function () {
                return this.getDrawOrders();
            }
        });
        let colorTimelineProto = window.spine.ColorTimeline.prototype;
        Object.defineProperty(colorTimelineProto, "frames", {
            get: function () {
                return this.getFrames();
            }
        });
        Object.defineProperty(colorTimelineProto, "slotIndex", {
            get: function () {
                return this.getSlotIndex();
            }
        });
        let trackEntryProto = window.spine.TrackEntry.prototype;
        Object.defineProperty(trackEntryProto, "loop", {
            get: function () {
                return this.getLoop();
            }
        });
        Object.defineProperty(trackEntryProto, "animationStart", {
            get: function () {
                return this.getAnimationStart();
            },
            set: function (value) {
            }
        });
        Object.defineProperty(trackEntryProto, "animationEnd", {
            get: function () {
                return this.getAnimationEnd();
            }
        });
        Object.defineProperty(trackEntryProto, "animationLast", {
            get: function () {
                return this.getAnimationLast();
            }
        });
        Object.defineProperty(trackEntryProto, "nextAnimationLast", {
            get: function () {
                return this.getAnimationLast();
            },
            set: function (value) {
                this.setNextAnimationLast(value);
            }
        });
        Object.defineProperty(trackEntryProto, "trackTime", {
            get: function () {
                return this.getTrackTime();
            }
        });
        Object.defineProperty(trackEntryProto, "animation", {
            get: function () {
                return this.getAnimation();
            }
        });
        let boneProto = window.spine.Bone.prototype;
        Object.defineProperty(boneProto, "a", {
            get: function () {
                return this.getA();
            }
        });
        Object.defineProperty(boneProto, "b", {
            get: function () {
                return this.getB();
            }
        });
        Object.defineProperty(boneProto, "c", {
            get: function () {
                return this.getC();
            }
        });
        Object.defineProperty(boneProto, "d", {
            get: function () {
                return this.getD();
            }
        });
        Object.defineProperty(boneProto, "worldX", {
            get: function () {
                return this.getWorldX();
            }
        });
        Object.defineProperty(boneProto, "worldY", {
            get: function () {
                return this.getWorldY();
            }
        });
        let eventProto = window.spine.Event.prototype;
        Object.defineProperty(eventProto, "volume", {
            get: function () {
                return this.getVolume();
            }
        });
        Object.defineProperty(eventProto, "balance", {
            get: function () {
                return this.getBalance();
            }
        });
        Object.defineProperty(eventProto, "time", {
            get: function () {
                return this.getTime();
            }
        });
        Object.defineProperty(eventProto, "data", {
            get: function () {
                return this.getData();
            }
        });
        Object.defineProperty(eventProto, "floatValue", {
            get: function () {
                return this.getFloatValue();
            }
        });
        Object.defineProperty(eventProto, "intValue", {
            get: function () {
                return this.getIntValue();
            }
        });
        Object.defineProperty(eventProto, "stringValue", {
            get: function () {
                return this.getStringValue();
            }
        });
        let eventDataProto = window.spine.EventData.prototype;
        Object.defineProperty(eventDataProto, "name", {
            get: function () {
                return this.getName();
            }
        });
        Object.defineProperty(eventDataProto, "audioPath", {
            get: function () {
                return this.getAudioPath();
            }
        });
    }
    static bindBuffer(maxNumVertices, maxNumIndices) {
        SpineAdapter._spine.createBuffer(maxNumVertices, maxNumIndices);
        SpineAdapter._vbArray = SpineAdapter._spine.getVertexsBuffer();
        SpineAdapter._ibArray = SpineAdapter._spine.getIndexsBuffer();
    }
    static drawSkeleton(fun, skeleton, twoColorTint, slotRangeStart, slotRangeEnd) {
        SpineAdapter._spine.drawSkeleton(fun, skeleton, twoColorTint, slotRangeStart, slotRangeEnd);
    }
}
SpineAdapter.stateMap = { 0: "start", 1: "interrupt", 2: "end", 3: "complete", 4: "dispose", 5: "event" };
class TextureAtlas {
    constructor(atlasText, textureLoader) {
        return new SpineAdapter._spine.Atlas(atlasText, "", SpineAdapter._spine.TextureLoader.implement({
            load: (page, url) => {
                let texture = textureLoader(url);
                page.texture = texture;
            },
            unload: function (s) {
            }
        }), true);
    }
}
Laya.addBeforeInitCallback(SpineAdapter.initialize);
